import { render, staticRenderFns } from "./ViewContentImg.vue?vue&type=template&id=354822b3&scoped=true"
import script from "./ViewContentImg.vue?vue&type=script&lang=js"
export * from "./ViewContentImg.vue?vue&type=script&lang=js"
import style0 from "./ViewContentImg.vue?vue&type=style&index=0&id=354822b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354822b3",
  null
  
)

export default component.exports